import { SHARE_PERMISSION } from '@/permissions/project/definitions'
import { useProjectAccess } from '../../../../../../../../../hooks'
import { LinkPermissionOptionLabels } from '../../../../../Share'

export const useGetLinkPermissionOptions = () => {
  const {
    hasAccess: hasAccessChangeLinkEditPermission,
    badgeType: badgeTypeChangeLinkEditPermission,
  } = useProjectAccess(SHARE_PERMISSION.CHANGE_LINK_EDiT_PERMISSION_TYPE)

  return [
    {
      label: 'Can view',
      value: LinkPermissionOptionLabels.CAN_VIEW,
      visible: true,
    },
    {
      label: 'Can comment',
      value: LinkPermissionOptionLabels.CAN_COMMENT,
      visible: true,
    },
    {
      label: 'Can edit',
      value: LinkPermissionOptionLabels.CAN_EDIT,
      visible: true,
      disabled: !hasAccessChangeLinkEditPermission,
      badgeType: badgeTypeChangeLinkEditPermission,
    },
  ]
}
